import classNames from 'classnames';
import { ReactNode } from 'react';

import ErrorList from '../../types/UI/ErrorList';
import fieldStyles from '../BaseField.module.css';
import ErrorMessage from '../ErrorMessage/ErrorMessage';
import Label from '../Label/Label';
import Stack from '../Stack/Stack';

type BlankFieldProps = {
    label?: ReactNode;
    errors?: ErrorList;
    children: ReactNode;
    hasErrors?: boolean;
    styleContent?: boolean;
    noPadding?: boolean;
};

const BlankField = ({
    label,
    errors,
    children,
    hasErrors = false,
    styleContent = false,
    noPadding = false,
}: BlankFieldProps) => {
    const classes = classNames({
        [fieldStyles.Field]: true,
        [fieldStyles['has-errors']]: hasErrors || (errors && errors.length),
    });

    const contentClasses = classNames({
        [fieldStyles.Input]: styleContent,
        [fieldStyles.Input_noPadding]: noPadding,
        [fieldStyles.VisualInput]: styleContent,
    });

    const errorMessage = (
        <ErrorMessage className={fieldStyles.Errors}>{errors}</ErrorMessage>
    );

    const content = <div className={contentClasses}>{children}</div>;

    if (label) {
        return (
            <label className={classes}>
                <Stack space="xsmall">
                    <Label>{label}</Label>
                    {content}
                    {errorMessage}
                </Stack>
            </label>
        );
    }

    return (
        <div className={classes}>
            <Stack space="small">
                {content}
                {errorMessage}
            </Stack>
        </div>
    );
};

export default BlankField;
